'use strict';

angular.module('DoohApps').directive('calendarHeight', ['DoohHelper', 'ScheduleHelper', function (DoohHelper, ScheduleHelper) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var defaultHeight = 800;
                scope.$watch(function () {
                    return scope.allDayCountForCalendarHeight
                }, function () {
                        
                    if (!scope.calendarOptions.calendar.eventLimit) {
                        var viewObj = element.fullCalendar('getView');
                        if (viewObj.start == null)
                            return;
                        var viewStart = DoohHelper.momentToDate(viewObj.start);
                        var viewEnd = DoohHelper.momentToDate(viewObj.end);

                        var allDayInView = ScheduleHelper.schedule.events.filter(function (scheduleEvent) {
                            var start = DoohHelper.stringToDate(scheduleEvent.start);
                            var end = DoohHelper.stringToDate(scheduleEvent.end);
                            return scheduleEvent.allDay && start < viewEnd && end > viewStart;
                        });

                        var multiplier = Math.floor(allDayInView.length / 7);//average events per day
                        var increaseHeightBy = 100 * multiplier;

                        element.fullCalendar('option', 'height', viewObj.name != 'month' ? defaultHeight + increaseHeightBy : 900);

                    } else element.fullCalendar('option', 'height', defaultHeight);
                    
                });
            }
        }
    }]);